import * as actions from "../actionTypes";
import Actions from "../actions";
import httpClient from "../../utils/HttpClient";
import { server } from "../../utils/Constants";
import { call, put, delay } from "redux-saga/effects";

export function* sagaGetTicketSupport() {
  try {
    yield put(Actions.getTicketSupportFetching());

    const response = yield call(httpClient.get, server.TICKET_SUPPORT);

    if (response.status == 200) {
      yield put(Actions.getTicketSupportSuccess(response.data.data));
    }
  } catch (error) {
    yield put(Actions.getTicketSupportFailed());
  }
}
